import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as fromModels from '@models';

import { ApplicationHttpClient } from '@base/http-client';

@Injectable()
export class ParameterService {
  private httpOptions = {};
  private rootEndpoint = 'parameters/';

  constructor(
    private http: ApplicationHttpClient,
  ) {}

  getParameters(): Observable<fromModels.Parameter[]> {
    return this.http.Get(this.rootEndpoint).pipe(
      map((params: fromModels.ApiResponse) => params.results),
      catchError((err: HttpErrorResponse) => throwError(err))
    );
  }
}
